import partyScribbles from "@assets/imgs/party-scribbles.png";
import { DSButton } from "@components/design-system/molecules";

export default function CelebrationBanner({
  dataTestId,
  onDiscoverMore,
}) {
  return (
    <div
      className="relative rounded-large p-[2px] overflow-hidden"
      data-testid={dataTestId}
      style={{
        background:
          "linear-gradient(var(--rainbow-angle, 0deg), #6366f1, #818cf8, #a78bfa, #c084fc, #e879f9, #f472b6, #fb7185, #f97316, #facc15, #34d399, #22d3ee, #6366f1)",
        animation: "rainbow-rotate 5s linear infinite",
      }}
    >
      <div className="bg-secondary rounded-large px-lg py-md flex items-center gap-md">
        <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full">
          <img
            src={partyScribbles}
            alt=""
            className="w-full scale-[1.4] origin-top transform translate-x-3 object-cover"
            draggable={false}
          />
        </div>
        <div className="flex-1">
          <p className="text-sm font-bold text-brand font-title">
            Look at you go!
          </p>
          <p className="text-xs text-secondary mt-xs">
            You&apos;ve completed all onboarding milestones. Happy
            scribing!
          </p>
        </div>
        {onDiscoverMore && (
          <DSButton
            variant="secondary"
            size="sm"
            dataTestId="celebration-discover-more"
            onClick={onDiscoverMore}
          >
            Discover More
          </DSButton>
        )}
      </div>

      <style>{`
        @property --rainbow-angle {
          syntax: "<angle>";
          initial-value: 0deg;
          inherits: false;
        }

        @keyframes rainbow-rotate {
          to {
            --rainbow-angle: 360deg;
          }
        }
      `}</style>
    </div>
  );
}
